export const IMPORTABLE_MODELS = [
  "location",
  "asset",
  "assetType",
  "intervention",
  "dataset",
];
